import React from "react";
import { useUserContext } from "context/UserContext";
import ManufacturerBK from "layouts/BK/manufacturer";
import { normalizeRoleLevel } from "utils/roleUtils";

function Manufacturer() {
  const { roleLevel } = useUserContext() || {};
  if (normalizeRoleLevel(roleLevel)) {
    return <ManufacturerBK />;
  }
  return null;
}

export default Manufacturer;
